import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { PendingException } from 'src/common/types';

import { Exception } from '../hosLog/types';
import { removeException, removePendingException } from '../store/hosLogStore';
import { pendingExceptionAdaper } from '../store/utils';
import { resetExceptionMarkedToRemove, setExceptionMarkedToRemove } from './store';

export const useExceptionActionCallback = () => {
  const dispatch = useDispatch();
  return useCallback(
    (exception: Exception, employeeId: number, exceptionDate: string) => (): void => {
      const timestamp = `${exceptionDate}T00:00:00+00:00`;

      const pendingException = pendingExceptionAdaper(
        exception,
        employeeId,
        exceptionDate,
        timestamp,
      );
      dispatch(setExceptionMarkedToRemove(pendingException));
    },
    [dispatch],
  );
};

export const usePendingExceptionAction = () => {
  const dispatch = useDispatch();

  return useCallback(
    (exception: PendingException) => (): void => {
      dispatch(setExceptionMarkedToRemove(exception));
    },
    [dispatch],
  );
};

export const useConfirmRemoveExceptionHandler = (exception: PendingException | undefined) => {
  const dispatch = useDispatch();
  return useCallback(() => {
    if (!exception) return;
    if (exception.exceptionId) {
      dispatch(removeException(exception));
    } else {
      dispatch(removePendingException(exception));
    }
    dispatch(resetExceptionMarkedToRemove());
  }, [dispatch, exception]);
};
